import React from 'react';
import { BallMoveTo } from '../Animations/BallMoveTo'
import PitchEntity from '../../components/Pitch/PitchEntity'
import * as MovementTypes from '../../constants/MovementTypes'
import * as BallMovementModes from '../../constants/BallMovementModes'
import * as RotationDirection from '../../constants/RotationDirection'
import * as THREE from 'three';
import * as MTLLoader from './Loaders/MTLLoader.js'
import { getInterval, getIntervalFromEvent } from './gameJson'
import { calculateDistance } from '../Animations/helper.js'

class Ball extends PitchEntity {

    static propTypes = {
        convertToPitchPosition: React.PropTypes.func.isRequired,
        getKeyPoints: React.PropTypes.func.isRequired,
        currentEvent: React.PropTypes.number.isRequired,
        gameSpeed: React.PropTypes.number.isRequired
    }

    constructor(props) {
        super(props);
        this.CurrentPosition = this.props.getKeyPoints(true).startPoint; 
        this.CurrentPosition.Height = 0;
        this.ball3d = null;
        this.lightPosition = new THREE.Vector3(-300,-300,800);
        this.planoref = new THREE.Plane(new THREE.Vector3(0,0,1));
    }

    componentDidMount() {
      if(this.props.pitch3d == true) {
        var THREE = require('three');
        var scene = this.refs.ball3d.parent;
        var _this = this;
        scene.remove(this.refs.ball3d);
        var mtlLoader = new THREE.MTLLoader();
        mtlLoader.setPath('/images/ball/' );
        mtlLoader.load('ball.mtl', function( materials ) {
          materials.preload();
          var OBJLoader = require('three-obj-loader');
          OBJLoader(THREE);
          var objLoader = new THREE.OBJLoader();
          objLoader.setMaterials( materials );
          objLoader.setPath( '/images/ball/' );
          objLoader.load( 'ball.obj', function ( object ) {
            var ball = object.children[3];
            ball.scale.set(3,3,3);
            ball.position.set(100,100,25);
            ball.castShadow = true;
            scene.add(ball);
            _this.ball3d = ball;
          }, function(){}, function(){} );
        });
      }
    }

    readEvent(eventNum) {
      if(eventNum == 0) {
        return { position: this.CurrentPosition, time: 1000, movementType: {type: MovementTypes.Short_Pass}};
      }
      var event = window.Json.game[eventNum-1];
      var nextEvent = eventNum < window.Json.game.length ? window.Json.game[eventNum] : null;
      var coordinates = event.coordinates;
      var time = getIntervalFromEvent(event);
      if(coordinates == null || coordinates.ball == null)
        return { position: this.CurrentPosition, time: time, movementType: {type: MovementTypes.Short_Pass}};

      var position = {
        Top: coordinates.ball.h,
        Left: coordinates.ball.w
      };

      var serverHeight = coordinates.ball.z;
      var ballMovementMode = this.getBallMovementMode(coordinates.ball.p);
      //var passOnHead = nextEvent != null && nextEvent.coordinates != null && nextEvent.coordinates.ball != null && nextEvent.coordinates.ball.p == 4;
      var passOnHead = event.coordinates.ball.p == 4;

      return { position, time, movementType: this.getMovementType(event, serverHeight, nextEvent), ballMovementMode: ballMovementMode, passOnHead: passOnHead };
    }

    getMovementType(event, serverHeight, nextEvent){
      let owner = this.getOwner(event);
      
      if(event.U != null) { //удар по воротам
        if(event.V != null) { //удар в свор
          return {type: MovementTypes.Shot, onGoal: true, serverHeight: serverHeight, rotation: this.getRotationDirection(event), isGoal: event.G != null, owner: owner};
        }
        else { //удар мимо
          return {type: MovementTypes.Shot, onGoal: false, serverHeight: serverHeight, rotation: this.getRotationDirection(event), isBlocked: event.U.team > 2,owner: owner};
        }
      }

      if(event.A != null) {
        return {type: MovementTypes.Out, rotation: RotationDirection.NONE, owner: owner};
      }

      if(serverHeight == 1) {
        let rotation = this.getRotationDirection(event);
        if(rotation == RotationDirection.NONE)
          return {type: MovementTypes.Long_Pass, rotation: rotation, owner: owner};
        else
          return {type: MovementTypes.Cross, rotation: rotation, owner: owner};
      }

      return {type: MovementTypes.Short_Pass, rotation: this.getRotationDirection(event), owner: owner};
    }

    getBallMovementMode(number) {
      if(number == null)
        return BallMovementModes.Pause;

      switch(number) {
        case 0:
          return BallMovementModes.Pause;
        case 1:
          return BallMovementModes.NoPause;
        case 2:
          return BallMovementModes.LinearNoPause;
        case 3:
          return BallMovementModes.NoPauseWithStop;
        case 4:
          return BallMovementModes.HeadPlay;
      }

      throw Error('unknown type');
    }

    getOwner(event) {
      if(event.messages != null && event.messages.length > 0)
        return event.messages[0].owner;
    }

    getRotationDirection(event) {
      if(event == null || event.coordinates == null)
        return RotationDirection.NONE;

      let ball = event.coordinates.ball;

      switch(ball.r) {
        case 0:
          return RotationDirection.NONE;
          break;
        case 1:
          return RotationDirection.LEFT;
          break;
        case 2:
          return RotationDirection.RIGHT;
          break;
      }
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.currentEvent != prevProps.currentEvent) {
        let {position, time, movementType, ballMovementMode, passOnHead} = this.readEvent(this.props.currentEvent);
        if(Math.abs(this.props.currentEvent - prevProps.currentEvent) > 1) {
          time = 30;
          this.moveToNewPosition(position, time, movementType, ballMovementMode, passOnHead, true);
        }
        else
          this.moveToNewPosition(position, time, movementType, ballMovementMode, passOnHead);
      }
    }

    moveToNewPosition(position, time, movementType, ballMovementMode, passOnHead, withOpacity = false) {
        this.cancelPreviousAnimation();
        this.playMovementAnimation(position, movementType, time, ballMovementMode, passOnHead, withOpacity);
    }

    playMovementAnimation(new_position, movementType, time, ballMovementMode, passOnHead, withOpacity) {
      movementType.ballMovementMode = ballMovementMode;
      movementType.passOnHead = passOnHead;
      movementType.withOpacity = withOpacity;

      ////////тут надо посчитать скорость линейного перемещения и заюзать ее в следующем такте
      if(ballMovementMode == BallMovementModes.LinearNoPause) {
        var distance = calculateDistance(this.CurrentPosition, new_position);
        this.LastLinearNoPause = distance / time * 100;
      }

      if(this.previousBallMovementMode == BallMovementModes.LinearNoPause){
        movementType.ballMovementMode = BallMovementModes.PauseWithDeceleration;
        movementType.initialSpeed = this.LastLinearNoPause;
      }
      this.previousBallMovementMode = movementType.ballMovementMode;
      ////////

      return BallMoveTo(this, this.props.gameSpeed, time, new_position, movementType, this.currentAnimationCancelationToken)
          .then(()=> this.currentAnimationCancelationToken = {}).catch(() => {});
    }

    convert_Height_to_html_size(z) {
      let min = 0;
      let max = 70;
      let minSize = 7;
      let maxSize = 10;
      return minSize + (z - min) / (max - min) * (maxSize - minSize) ;
    }

    setCurrentPosition(top, left, height){
      this.CurrentPosition.Top = Number((top).toFixed(1));
      this.CurrentPosition.Left = Number((left).toFixed(1));

      this.CurrentPosition = this.CurrentPosition;

      if(height != null)
          this.CurrentPosition.Height = Number((height).toFixed(1));

      if(this.props.pitch3d == true) {
        this.ball3d.position.set(left, top, this.CurrentPosition.Height + 2);
      } else {
        this.forceUpdate();
      }
    }

    render() {
        //for 3d pitch:
        if(this.props.pitch3d == true){
          console.log('render 3d ball');
          return (
            <mesh ref="ball3d">
              <boxGeometry
                width={5}
                height={5}
                depth={5}
              />
              <meshBasicMaterial
                color={0xff0000}
              />
            </mesh>);
          }
        //for 2d pitch:
        var position = this.props.convertToPitchPosition(this.CurrentPosition);
        var size = this.convert_Height_to_html_size(this.CurrentPosition.Height);
        var top = position.Top - size / 2;
        var left = position.Left - size / 2;
        var ray = new THREE.Ray(this.lightPosition, new THREE.Vector3(this.CurrentPosition.Top - this.lightPosition.x, this.CurrentPosition.Left - this.lightPosition.y, this.CurrentPosition.Height-this.lightPosition.z).normalize());
        var shadowLocation = ray.intersectPlane(this.planoref);
        var shadow_position = this.props.convertToPitchPosition({Top: shadowLocation.x, Left: shadowLocation.y});

        const divStyle = {
          top: top + 'px',
          left: left + 'px',
          height: size + 'px',
          width: size + 'px',
          zIndex: this.CurrentPosition.Height > 2.44 * 100/16.5 ? 4 : 2,
          opacity: this.opacity
        };

        const shadowDivStyle = {
          top: shadow_position.Top - 3.5,
          left: shadow_position.Left - 3.5,
          opacity: this.opacity
        }

        return (<div>
                  <div ref={(div) => { this.Div = div; }} style={divStyle} className={"ball"+this.props.weather}> </div>
                  <div style={shadowDivStyle} className="ball_shadow"></div>
              </div>
)
    }
}

export default Ball



/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Ball.js
 **/